import { DeclarationPropertiesViews } from "../../data/enums/declarationPropertiesViews";
import { ApiData } from "../../data/apiData";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { CatalogOperationModel } from "../../models/operations/catalogOperationModel";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import { decodeXml } from "../../utilities/index";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

/**Модель представления операции */
export class OperationPropertiesVue extends Vue {
  /** Id операции в каталоге */
  @Prop() operationModel!: CatalogOperationModel;

  /**Действие */
  @Prop() action!: Function;

  /**Признак блокировки */
  @Prop() disable!: boolean;

  @Prop() onFocusAction!: Function;

  // get getOperationModel(): OperationModel {
  //   return this.operationModel
  // }

  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get filteredProps(): Array<OperationPropertyModel> {
    let filterKeys: Array<string> = [];
    const operCode: string = this.operationModel.Declaration?.Id.toString();
    const apiData: ApiData = this.configStore.apiData;

    if (operCode === apiData.OperationCodeOfSbpOperation
      || operCode === apiData.OperationCodeOfToOtherContractByPhone) {
      filterKeys = ['contract', 'contractTo', 'type', 'card', 'bankID', 'receiverName', 'sum', 'course', 'sumTo', 'messageToClient'];
    } else if (operCode === apiData.OperationCodeOfMe2MeOperation) {
      filterKeys = ['bankID', 'contract', 'sum', 'comment'];
    } 
    
    // else if (operCode === apiData.OperationCodeOfToOtherContractByCard) {
    //   filterKeys = ['contract', 'card', 'receiverBank', 'receiverName', 'sum'];
    // }
    if (filterKeys.length > 0) {
      const resArr: Array<OperationPropertyModel> = [];
      filterKeys.map((key: string) => {
        const prop: OperationPropertyModel = this.operationModel.Properties.find((prop: OperationPropertyModel) => prop.Declaration.Name == key);
        if (prop) {
          resArr.push(prop);
        }
      });
      this.operationModel.Properties.map((prop: OperationPropertyModel) => {
        if (filterKeys.indexOf(prop.Declaration.Name) !== -1)
          resArr.push()
      });
      return resArr;
    } else
      return this.operationModel.Properties;
  }

  /**Признак видимости блока информации */
  infoVisible: boolean = false;

  /**Текст информации */
  infoText: string = "";

  /**Показать инфомрацию */
  showInfo(text: string): void {
    this.infoVisible = true;
    this.infoText = decodeXml(text.replace(/\n/g, "<br>"));
  }

  /**Скрыть информацию */
  closeInfo(): void {
    this.infoVisible = false;
    this.infoText = "";
  }

  /**Признак видимости */
  isVisible(property: OperationPropertyModel): boolean {
    return property.Declaration.View != DeclarationPropertiesViews.Hidden && property.Declaration.Type != DeclarationPropertiesTypes.Unknown;
  }
}
